var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSsd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 44,
    viewBox: "0 0 105 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_25539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2081 11.171C53.3246 11.2269 54.7311 11.0909 56.1374 11.263C58.6759 11.5709 61.0224 13.9507 61.2929 16.5384C61.379 17.3464 61.3006 17.4425 60.525 17.4425C59.5417 17.4464 58.5546 17.4344 57.5712 17.4464C57.2029 17.4504 56.9874 17.3425 56.8661 16.9504C56.6036 16.1025 56.1805 15.8225 55.3069 15.8105C53.3207 15.7904 51.3307 15.8344 49.3445 15.7464C47.8519 15.6785 46.8921 16.5186 46.9273 17.7584C46.9587 18.9142 47.6521 19.6381 48.7882 19.6463C50.7155 19.6622 52.6469 19.6421 54.5744 19.6542C56.2589 19.6663 57.7514 20.1861 59.0597 21.318C62.2173 24.0458 61.8648 29.4692 58.3665 31.7291C57.2773 32.4331 56.0982 32.781 54.8329 32.8011C52.7253 32.8291 50.6137 32.825 48.5062 32.8011C45.3564 32.765 42.8258 30.4172 42.442 27.2375C42.3753 26.6856 42.5241 26.5016 43.0686 26.5175C44.1108 26.5496 45.1567 26.5376 46.2027 26.5216C46.5709 26.5175 46.7707 26.6216 46.8921 27.0215C47.1547 27.9015 47.6481 28.2334 48.5493 28.2375C50.5393 28.2414 52.5255 28.2414 54.5156 28.2334C55.3382 28.2294 56.0865 28.0054 56.5017 27.2014C57.199 25.8617 56.3254 24.3377 54.8368 24.3179C52.8272 24.2897 50.8174 24.3179 48.8117 24.3018C46.2419 24.2818 43.8639 22.6179 42.8923 20.1782C41.2001 15.9306 44.1813 11.279 48.6785 11.163C49.7519 11.147 50.837 11.171 52.2081 11.171Z",
    fill: "url(#paint0_linear_173_25539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7258 32.829C28.3389 32.7451 26.9247 32.9649 25.5341 32.6849C22.8193 32.137 20.7587 29.7533 20.6451 27.1055C20.6256 26.6655 20.7509 26.5216 21.1701 26.5295C22.2551 26.5496 23.3403 26.5496 24.4215 26.5295C24.8133 26.5216 24.9817 26.6856 25.0915 27.0615C25.3382 27.8934 25.7769 28.2294 26.6428 28.2374C28.6916 28.2533 30.7405 28.2734 32.7892 28.2294C34.5599 28.1934 35.4492 26.6536 34.5992 25.1818C34.2348 24.5498 33.6589 24.3218 32.9735 24.3218C31.0459 24.3179 29.1186 24.3298 27.1912 24.3137C25.3226 24.2978 23.6498 23.6859 22.3766 22.2698C20.6293 20.326 20.175 18.0264 21.0055 15.5306C21.8322 13.0468 23.5988 11.5509 26.1256 11.2909C28.9187 11.0069 31.755 10.951 34.5404 11.327C37.071 11.671 39.0768 13.7027 39.4764 16.5824C39.5821 17.3424 39.4725 17.4424 38.7241 17.4464C37.741 17.4504 36.7577 17.4384 35.7703 17.4504C35.41 17.4544 35.1907 17.3703 35.0653 16.9624C34.8185 16.1505 34.223 15.7066 33.3886 15.7464C31.2223 15.8545 29.0521 15.7746 26.8856 15.8225C25.8749 15.8466 25.0484 16.7384 25.0601 17.7423C25.0719 18.7622 25.8867 19.6381 26.8974 19.6503C28.9071 19.6702 30.9129 19.6461 32.9224 19.6622C36.0369 19.6861 38.6342 21.838 39.2922 24.9097C40.0835 28.6093 37.549 32.2531 33.8862 32.721C32.5072 32.897 31.1244 32.753 29.7258 32.829Z",
    fill: "url(#paint1_linear_173_25539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5678 25.8416C64.5678 23.7498 64.5835 21.658 64.556 19.5702C64.5521 19.0783 64.7049 18.9502 65.1711 18.9664C66.2326 19.0022 67.3021 19.0022 68.3637 18.9664C68.873 18.9502 69.0454 19.0743 69.0414 19.6381C69.0102 22.2619 69.0494 24.8857 69.0141 27.5094C69.0063 28.1295 69.2021 28.2615 69.7623 28.2414C70.9062 28.2014 72.054 28.1735 73.194 28.2414C76.2613 28.4214 79.5716 25.4737 79.1878 21.45C78.8744 18.1584 76.3241 15.8065 73.0099 15.7746C70.4008 15.7506 67.7879 15.7586 65.1789 15.7825C64.7167 15.7865 64.5403 15.6866 64.556 15.1786C64.5951 14.0107 64.5795 12.8429 64.5678 11.675C64.5638 11.3149 64.6774 11.179 65.0535 11.1829C68.0269 11.215 71.0001 11.147 73.9696 11.255C78.3416 11.411 82.2786 14.8746 83.3716 19.3823C84.8368 25.4217 81.2013 31.3691 75.2546 32.6571C74.8003 32.7571 74.3457 32.813 73.8796 32.813C70.9689 32.809 68.0543 32.8011 65.1436 32.8209C64.6893 32.8251 64.556 32.6891 64.5599 32.2411C64.5755 30.1053 64.5678 27.9735 64.5678 25.8416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36486 20.8461L18.8704 44H13.7268C11.4116 44 9.34318 42.5362 8.52834 40.3243L3.51398 26.7216L7.36486 20.8461Z",
    fill: "url(#paint2_linear_173_25539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5231 9.84312L7.6038 9.63513C6.27969 9.58714 5.06135 10.3511 4.49724 11.575L0.270284 20.8021C-0.105793 21.6221 -0.0862055 22.574 0.321212 23.3819L7.60771 37.7886C7.60771 37.7886 3.9762 29.9173 7.94461 21.6501C11.913 13.3828 13.5231 9.84312 13.5231 9.84312Z",
    fill: "url(#paint3_linear_173_25539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75057 9.71113C9.14335 10.731 2.23686 26.0857 1.95873 26.6215L0.321212 23.3819C-0.0862055 22.5779 -0.105793 21.6221 0.270284 20.8021L4.50115 11.575C5.06135 10.3511 6.28361 9.58714 7.6077 9.63513L9.75057 9.71113Z",
    fill: "#32D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6352 23.1297L86.0551 0.0158482L91.2028 -0.000150307C93.518 -0.00814958 95.5942 1.44772 96.4169 3.65952L101.474 17.2463L97.6352 23.1297Z",
    fill: "#B4B5B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5122 34.1569L97.4314 34.3449C98.7555 34.3889 99.9739 33.621 100.53 32.3931L104.73 23.1539C105.102 22.3299 105.082 21.3781 104.671 20.5741L97.3412 6.19543C97.3412 6.19543 100.996 14.0507 97.0593 22.334C93.1222 30.6173 91.5122 34.1569 91.5122 34.1569Z",
    fill: "url(#paint4_linear_173_25539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2886 34.277C95.8918 33.2531 102.591 18.1823 103.022 17.3264L104.679 20.5741C105.09 21.3782 105.11 22.33 104.737 23.1539L100.534 32.3931C99.9778 33.617 98.7595 34.3849 97.4354 34.3449L95.2886 34.277Z",
    fill: "#32D5CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_25539",
    x1: 42.4009,
    y1: 21.9949,
    x2: 61.3163,
    y2: 21.9949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DE7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35D4C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_25539",
    x1: 20.6066,
    y1: 21.9467,
    x2: 39.5137,
    y2: 21.9467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DE7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35D4C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_173_25539",
    x1: 12.3348,
    y1: 38.7196,
    x2: 6.36711,
    y2: 24.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B5B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_173_25539",
    x1: -0.000021064,
    y1: 23.7078,
    x2: 13.5245,
    y2: 23.7078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DE7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35D4C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_173_25539",
    x1: 104.993,
    y1: 20.2446,
    x2: 91.4681,
    y2: 20.2879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DE7DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35D4C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_25539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSsd);
export default __webpack_public_path__ + "static/media/LogoSSD.e531f303283f42222b65734e4f557892.svg";
export { ForwardRef as ReactComponent };